export default __webpack_public_path__ + "static/media/Grupo6137.ba5fc136.svg";